import { cacheStep, } from "./types";
import { AgentStateProxy } from "./AgentStateProxy";
export class JsCustomBehavior {
    constructor(src, properties, datasets, agentCache) {
        this.name = src.name;
        this.dependencies = src.dependencies;
        this.inner = src.behavior;
        this.properties = properties;
        this.datasets = datasets;
        this.agentCache = agentCache;
    }
    apply(stateWrapper, contextWrapper) {
        const context = {
            messages: () => contextWrapper.messages(),
            neighbors: () => this.retrieveNeighbors(contextWrapper.neighbors()),
            globals: () => this.properties,
            data: () => this.datasets,
            step: () => this.agentCache[cacheStep],
        };
        const state = new AgentStateProxy(stateWrapper);
        try {
            this.inner(state, context);
            try {
                this.flushCache(state);
            }
            catch (err) {
                throw new Error(`error setting agent state after behavior ${this.name}: ${err.message}`);
            }
        }
        catch (e) {
            e.args = {
                context: {
                    messages: JSON.parse(JSON.stringify(context.messages())),
                    neighbors: JSON.parse(JSON.stringify(context.neighbors())),
                },
            };
            throw e;
        }
        finally {
            state.wrapper.free();
            contextWrapper.free();
        }
    }
    flushCache(state) {
        state.cache.forEach((value, key) => {
            try {
                state.wrapper.set(key, value);
            }
            catch (err) {
                const agent_id = state.wrapper.get("agent_id");
                throw new Error(`could not set state variable '${key}' to value ${JSON.stringify(value)} on agent with id '${agent_id}': ${err.message}`);
            }
        });
    }
    updateProperties(props) {
        this.properties = props;
    }
    retrieveNeighbors(neighbor_ids) {
        const currentStep = this.agentCache[cacheStep];
        return neighbor_ids.map((id) => {
            const neighbor = this.agentCache[id];
            if (!neighbor) {
                throw new Error(`Cache Error: neighbor ${id} not found`);
            }
            if (neighbor[cacheStep] !== currentStep) {
                throw new Error(`Cache Error: neighbor ${id} is outdated`);
            }
            return neighbor;
        });
    }
}
//# sourceMappingURL=JsCustomBehavior.js.map